module.exports = __webpack_public_path__ + "static/media/tick.6bd0f7c8.svg";